import odocStore from './store'

export default class OdocModule {
  name = 'odoc'
  constructor({ store }) {
    store.registerModule(this.name, odocStore)
  }
}
